import { render } from "./ProductsShare.vue?vue&type=template&id=2c3e6ddc&scoped=true"
import script from "./ProductsShare.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsShare.vue?vue&type=script&setup=true&lang=js"

import "./ProductsShare.vue?vue&type=style&index=0&id=2c3e6ddc&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3e6ddc"],['__file',"resources/js/components/whatsapp-managment/includes/types/ProductsShare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c3e6ddc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c3e6ddc', __exports__)) {
    console.log('reload')
    api.reload('2c3e6ddc', __exports__)
  }
  
  module.hot.accept("./ProductsShare.vue?vue&type=template&id=2c3e6ddc&scoped=true", () => {
    console.log('re-render')
    api.rerender('2c3e6ddc', render)
  })

}


export default __exports__